import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/Card';

export function SectionCard({ title, description, children, className = '', headerAction = null }) {
  return (
    <Card className={`flex h-full w-full min-w-0 flex-col ${className}`}>
      <CardHeader className="px-4 py-3">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between sm:gap-3">
          <div className="min-w-0 flex-1">
            <CardTitle>{title}</CardTitle>
            {description ? <CardDescription>{description}</CardDescription> : null}
          </div>
          {headerAction ? <div className="flex-shrink-0">{headerAction}</div> : null}
        </div>
      </CardHeader>
      <CardContent className="flex min-w-0 flex-1 flex-col px-4 py-4">{children}</CardContent>
    </Card>
  );
}
